import { Eyebrow, Reveal } from "@/components/Reveal";

const ABOUT_IMG = "https://images.unsplash.com/photo-1584602667746-f7537353bf4d?crop=entropy&cs=srgb&fm=jpg&q=85";
const TURMERIC_IMG = "https://images.unsplash.com/photo-1768729340164-7d83fe18384d?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-sand py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-8 lg:grid-cols-2 lg:gap-20 lg:px-16">
        <Reveal className="relative">
          <div className="overflow-hidden rounded-3xl">
            <img src={ABOUT_IMG} alt="Indian farm sourcing" className="aspect-[4/5] w-full object-cover" />
          </div>
          <div className="absolute -bottom-8 -right-4 hidden w-52 overflow-hidden rounded-2xl border-4 border-sand shadow-2xl sm:block lg:-right-10">
            <img src={TURMERIC_IMG} alt="Turmeric roots and powder" className="aspect-square w-full object-cover" />
          </div>
          <div className="absolute -left-3 top-8 rounded-2xl bg-botanical px-5 py-4 shadow-xl lg:-left-8">
            <div className="font-serif text-3xl font-bold text-amberwarm">100%</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-cream/80">Direct Farm Sourcing</div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <Eyebrow>About Tsugiva</Eyebrow>
            <h2 className="mt-3 font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl lg:text-5xl">
              Rooted in Indian farms, built for global trade
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-6 text-base leading-relaxed text-smoke">
              Tsugiva International Traders is an export house specialising in finger turmeric, red
              chillies of every grade and our own line of 100% cold pressed oils — groundnut,
              sunflower, sesame, flaxseed and extra virgin olive.
            </p>
            <p className="mt-4 text-base leading-relaxed text-smoke">
              We work directly with farmer collectives across the spice belts of Tamil Nadu, Andhra Pradesh and
              Telangana, then process every batch at low temperature in traditional wooden presses. Nothing
              refined, nothing solvent-extracted — just the honest essence of the crop, sealed for its journey
              across the world.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9 grid grid-cols-3 gap-4">
              {[
                { v: "3", l: "Farm-Belt States" },
                { v: "45°C", l: "Max Press Temp" },
                { v: "0", l: "Chemical Solvents" },
              ].map((s) => (
                <div key={s.l} className="rounded-2xl border border-stone2 bg-white px-4 py-5 text-center">
                  <div className="font-serif text-2xl font-bold text-gold sm:text-3xl">{s.v}</div>
                  <div className="mt-1 text-[10px] uppercase tracking-[0.14em] text-pebble">{s.l}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
